module.exports = __webpack_public_path__ + "img/Saved.04bc469f.png";